import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../resources/ResourcesStore";
import { injectFromAppLegal } from "../inject";
import { ImpressumNL } from "./ImpressumNL";
import { ImpressumFR } from "./ImpressumFR";
import { ImpressumDE } from "./ImpressumDE";
import { ImpressumEN } from "./ImpressumEN";
import { LegalPartialContainerComponent } from "../LegalPartialContainerComponent";

interface IImpressumComponentProps {
    resourcesStore?: IResourcesStore;
}

@injectFromAppLegal<IImpressumComponentProps>(stores => ({
    resourcesStore: stores.resourcesStore,
}))
@observer
export class ImpressumComponent extends React.Component<IImpressumComponentProps> {
    render() {
        const { resourcesStore } = this.props;
        const { currentLanguage, resources } = resourcesStore!;

        let translatedImpressum;

        switch (currentLanguage) {
            case "nl":
                translatedImpressum = <ImpressumNL />;
                break;
            case "fr":
                translatedImpressum = <ImpressumFR />;
                break;
            case "de":
                translatedImpressum = <ImpressumDE />;
                break;
            case "en":
            case "es":
            case "pt-br":
            case "no":
            case "it":
            default:
                translatedImpressum = <ImpressumEN />;
                break;
        }

        return (
            <LegalPartialContainerComponent title={resources.Imprint} className={" impressum "}>
                {translatedImpressum}
            </LegalPartialContainerComponent>
        );
    }
}
